<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>从业信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">从业信息</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <div style="display: flex; align-items: center;">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未申报" value="0"></el-option>
                    <el-option label="已申报" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量申报</el-button
          >
          <el-button type="primary" @click="exportList()" class="btn"
            >导出申报excel</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="cardName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="cardTypeName" label="证件类型" align="center">
          </el-table-column>
          <el-table-column prop="cardCode" label="证件编号" align="center">
          </el-table-column>
          <el-table-column prop="nation" label="国籍" align="center">
          </el-table-column>
          <el-table-column prop="sexName" label="性别" align="center">
          </el-table-column>
          <el-table-column prop="birthday" label="出生日期" align="center">
          </el-table-column>
          <el-table-column
            prop="employType"
            label="任职受雇从业类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="phone" label="手机号" align="center">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="任职受雇从业日期"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="position" label="职务" align="center">
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.isDeclare == 0"
                >未申报</span
              >
              <span class="greenColor" v-if="scope.row.isDeclare == 1"
                >已申报</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.isDeclare == 0">
                <div class="operateBtn" @click="Invoicing(scope.row)">
                  提交申报
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <el-dialog
      title="从业人员信息采集"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-select v-model="status" placeholder="请选择">
          <el-option label="申报成功" value="1"> </el-option>
          <el-option label="申报失败" value="0"> </el-option>
        </el-select>
        <div style="margin-top: 20px" v-if="status == '0'">失败描述：</div>
        <el-input
          v-if="status == '0'"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="failDesc"
          style="margin-top: 5px"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px;overflow-y: scroll;">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        time: "",
        time1: ""
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible: false,
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0" //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList() {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        ids: arr,
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        isDeclare: this.ruleForm.status
      };
      this.$axios
        .post("admapi/tax/bodyguard/export", param, { responseType: "blob" })
        .then(data => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8"
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      let that = this;
      let arr = [];
      if (that.multipleTable.length != 0) {
        for (var i = 0; i < that.multipleTable.length; i++) {
          arr.push(that.multipleTable[i].id);
        }
      } else {
        that.$message({
          message: "请选择申报数据",
          type: "warning"
        });
        return;
      }
      that
        .$confirm("请确认是否进行批量申报操作", "操作提醒", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that.$axios
            .post(`/admapi/tax/bodyguard/batchsubmit`, {
              ids: arr
            })
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success"
              });
              that.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    confrim() {
      if (this.status == "") {
        return;
      }
      if (this.status == "0") {
        if (this.failDesc == "") {
          this.$message({
            message: "请输入失败原因",
            type: "warning"
          });
          return;
        }
      }
      if (this.type == "0") {
        let param = {
          id: this.selectData.id,
          state: this.status,
          failDesc: this.failDesc
        };
      } else {
        if (this.multipleTable.length == 0) {
          this.$message({
            message: "请选择申报数据",
            type: "warning"
          });
          return;
        }
        let arr = [];
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
        let param = {
          ids: arr,
          state: this.status,
          failDesc: this.failDesc
        };
        this.$axios
          .post(`/admapi/withdraw/tempbatchconfirm`, param)
          .then(({ data }) => {
            if (data.errorCount != 0) {
              this.errorList = data.errorMessages;
              this.dialogVisible1 = true;
            } else {
              this.$message({
                message: "批量申报成功",
                type: "success"
              });
            }
            this.multipleTable = [];
            this.$refs.multipleTable.clearSelection();
            this.getList();
            this.dialogVisible = false;
          })
          .catch()
          .finally();
      }
    },
    Invoicing(val) {
      this.$confirm("请确认是否进行申报操作", "操作提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(`/admapi/tax/bodyguard/submit`, {
              id: val.id
            })
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success"
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.page = 1;
      this.pageSize = 20;
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        isDeclare: this.ruleForm.status
      };
      this.$axios
        .post(`/admapi/tax/bodyguard/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
